var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect } from 'react';
import { DialogContext } from '../../context/dialog';
import { UserContext } from '../../context/user';
import { DialogType } from '../../types/dialogs';
import { useMetamask } from './use-metamask';
export function useLocalWallet() {
    var t = useI18n().t;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _a = useContext(UserContext), localWalletAddress = _a.localWalletAddress, addLocalWallet = _a.addLocalWallet, removeLocalWallet = _a.removeLocalWallet;
    var _b = useMetamask(false, 'eth'), connectMetamask = _b.connectMetamask, metamaskWalletAddress = _b.metamaskWalletAddress, metamaskConnected = _b.metamaskConnected, metamaskErrorMessage = _b.metamaskErrorMessage, setMetamaskErrorMessage = _b.setMetamaskErrorMessage;
    useEffect(function () {
        setDialogProps(metamaskErrorMessage
            ? {
                common: {
                    title: t('common.error'),
                    close: { text: t('common.back'), action: function () { return setMetamaskErrorMessage(undefined); } },
                },
                custom: {
                    type: DialogType.SIMPLE,
                    message: metamaskErrorMessage,
                },
            }
            : undefined);
    }, [metamaskErrorMessage]);
    function connectLocalWallet() {
        return __awaiter(this, void 0, void 0, function () {
            var walletAddress;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, connectMetamask()];
                    case 1:
                        walletAddress = _a.sent();
                        if (walletAddress) {
                            addLocalWallet(walletAddress);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function closeDialog() {
        setMetamaskErrorMessage(undefined);
        setDialogProps(undefined);
    }
    function showLocalWalletUnlinkDialog() {
        setDialogProps({
            common: {
                title: t('common.unlink'),
                close: { text: t('common.back'), action: closeDialog },
                actions: [{ text: t('common.confirm'), action: unlinkLocalWallet, highlighted: true }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('account.wallets.local-wallet.unlink.confirm-message'),
            },
        });
    }
    function unlinkLocalWallet() {
        removeLocalWallet();
        setDialogProps({
            common: {
                title: t('common.success'),
                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('account.wallets.local-wallet.unlink.success-message'),
            },
        });
    }
    return {
        connectMetamask: connectLocalWallet,
        metamaskWalletAddress: metamaskWalletAddress,
        metamaskConnected: metamaskConnected,
        metamaskErrorMessage: metamaskErrorMessage,
        setMetamaskErrorMessage: setMetamaskErrorMessage,
        localWalletAddress: localWalletAddress,
        showLocalWalletUnlinkDialog: showLocalWalletUnlinkDialog,
    };
}
